<script setup lang="ts">
import { createInlineConfirmGroup } from "@/composables/createInlineConfirm"

createInlineConfirmGroup()
</script>

<template>
    <slot></slot>
</template>
